interface ArchiveStatsData {
  totalPlayed: number
  successRate: number
  avgScore: number
  totalStars: number
}

interface ArchiveStatsProps {
  stats: ArchiveStatsData
  isLoading?: boolean
  signatureColor: string
  scoreDescriptor: string
}

export function ArchiveStats({ stats, isLoading = false, signatureColor, scoreDescriptor }: ArchiveStatsProps) {
  // Loading skeleton
  if (isLoading) {
    return (
      <div className="bg-white dark:bg-gray-800 rounded-2xl p-6 mt-6 shadow-sm">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 text-center">
          {[1, 2, 3, 4].map((i) => (
            <div key={i} className="p-4 animate-pulse">
              <div className="h-10 bg-gray-200 dark:bg-gray-700 rounded-lg mb-2 mx-auto w-20" />
              <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded w-32 mx-auto" />
            </div>
          ))}
        </div>
      </div>
    )
  }

  return (
    <div className="bg-white dark:bg-gray-800 rounded-2xl p-6 mt-6 shadow-sm">
      <div className="grid grid-cols-2 md:grid-cols-4 gap-6 text-center">
        {/* Total Played */}
        <div className="p-4">
          <div className="text-4xl font-bold tracking-wide"
               style={{ fontFamily: 'Bebas Neue, sans-serif', color: signatureColor }}>
            {stats.totalPlayed}
          </div>
          <div className="text-xs font-semibold text-gray-600 dark:text-gray-400 uppercase tracking-wide mt-1"
               style={{ fontFamily: 'Oswald, sans-serif' }}>
            Challenges Played
          </div>
        </div>

        {/* Success Rate */}
        <div className="p-4">
          <div className="text-4xl font-bold tracking-wide"
               style={{ fontFamily: 'Bebas Neue, sans-serif', color: signatureColor }}>
            {Math.round(stats.successRate)}%
          </div>
          <div className="text-xs font-semibold text-gray-600 dark:text-gray-400 uppercase tracking-wide mt-1"
               style={{ fontFamily: 'Oswald, sans-serif' }}>
            Success Rate
          </div>
        </div>

        {/* Average Score */}
        <div className="p-4">
          <div className="text-4xl font-bold tracking-wide"
               style={{ fontFamily: 'Bebas Neue, sans-serif', color: signatureColor }}>
            {stats.avgScore.toFixed(1)}
          </div>
          <div className="text-xs font-semibold text-gray-600 dark:text-gray-400 uppercase tracking-wide mt-1"
               style={{ fontFamily: 'Oswald, sans-serif' }}>
            Avg {scoreDescriptor}
          </div>
        </div>

        {/* Total Stars */}
        <div className="p-4">
          <div className="text-4xl font-bold tracking-wide"
               style={{ fontFamily: 'Bebas Neue, sans-serif', color: signatureColor }}>
            {stats.totalStars}
          </div>
          <div className="text-xs font-semibold text-gray-600 dark:text-gray-400 uppercase tracking-wide mt-1"
               style={{ fontFamily: 'Oswald, sans-serif' }}>
            Total Stars
          </div>
        </div>
      </div>
    </div>
  )
}
